/*
 * @author: 
 * @Date: 2021-12-14 13:40:38
 * @LastEditTime: 2023-12-01 13:35:22
 * @FilePath: \场外----客户\src\store\modules\manager.js
 */
import { managerLogin, defaultLogin } from "@/api/manager"
import { getCookie, setCookie,removeCookie, removeCookieByName } from '@/utils/auth'

const state = {
  sessionKey: getCookie('managerSessionKey'),
  id: getCookie('managerId'),
  name: getCookie('managerName'),
  // phoneNumber: getCookie('phoneNumber'),
  // role: getCookie('role'),
  // masterCanOrder: getCookie('masterCanOrder'),
}

const mutations = {
  SET_SESSION_KEY: (state, key) => {
      state.sessionKey = key
  },
  SET_MANAGER_ID: (state, id) => {
      state.id = id
  },
  SET_MANAGER_NAME: (state, name) => {
      state.name = name
  },
  // SET_ROLE: (state, role) => {
  //   state.role = role
  // },
  // SET_MASTERCANORDER: (state, masterCanOrder) => {
  //   state.masterCanOrder = masterCanOrder
  // },
  // SET_PHONE_NUMBER: (state, phoneNumber) => {
  //   state.phoneNumber = phoneNumber
  // },
}
const actions = {
  managerLogin({ commit }, custInfo) {
    const { user_name, pass_word, remPwd, check_code, check_code_token } = custInfo
    let user_code = user_name.trim()
    return new Promise((resolve, reject) => {
      managerLogin({ user_code: user_code, pass_word: pass_word, check_code: check_code, check_code_token: check_code_token }).then(resp => {
        let response = resp.data
        commit('SET_MANAGER_ID', response.user_id)
        commit('SET_MANAGER_NAME', response.user_name)
        commit('SET_SESSION_KEY', response.loginKey)
        // commit('SET_PHONE_NUMBER', response.phoneNumber)
        // commit('SET_ROLE', response.role)
        // commit('SET_MASTERCANORDER', response.masterCanOrder)
        if (remPwd) {
          setCookie('managerId', response.user_id)
          setCookie('managerName', response.user_name)
          setCookie('managerSessionKey', response.loginKey)
          // setCookie('phoneNumber', response.phoneNumber)
          // setCookie('role', response.role)
          // setCookie('masterCanOrder', response.masterCanOrder)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({ commit }){
    commit('SET_MANAGER_ID', '')
    commit('SET_MANAGER_NAME', '')
    commit('SET_SESSION_KEY', '')
    // commit('SET_ROLE', '')
    // commit('SET_PHONE_NUMBER', '')
    // commit('SET_MASTERCANORDER','')
    removeCookie() // 删除默认的cookie
    removeCookieByName('showQuoteTip') //删除是否显示场外提示的cookie
  },
  defaultLogin({ commit }, params) {
    const { user_code, user_pwd } = params
    return new Promise((resolve, reject) => {
      defaultLogin({ user_code: user_code, user_pwd: user_pwd }).then(resp => {
        let response = resp.data
        commit('SET_MANAGER_ID', response.user_id)
        commit('SET_MANAGER_NAME', response.user_name)
        commit('SET_SESSION_KEY', response.loginKey)
        // commit('SET_PHONE_NUMBER', response.phoneNumber)
        // commit('SET_ROLE', response.role)
        // commit('SET_MASTERCANORDER', response.masterCanOrder)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}